import React, { useContext, useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import InputField from 'components/Form/InputField';
import { Form, Formik, Field, FieldArray } from 'formik';
import ScheduleInitialExport from 'components/ScheduleInitialExport';
import * as yup from 'yup';
import { Button, SelectField } from 'components/index';
import { CacheManager, MessageCenter } from 'utils';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import { now } from 'lodash';

export default function Test2Page() {
  const [selectedDay, setSelectedDay] = useState("");
  const date = new Date();
  //const daysBefore = new Date(now()+ 15);
  const insurer = 'Argo';
  const MONTHS = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ];
  const WEEKDAYS_LONG = [
    "Segunda-Feira",
    "Terça-Feira",
    "Quarta-Feira",
    "Quinta-Feira",
    "Sexta-Feira",
    "Sábado",
    "Domingo",
  ];
  const WEEKDAYS_SHORT = ["DOM", "SEG", "TER", "QUA", "QUI", "SEX", "SÁB"];

  useEffect(() => {
    /*  

    const dataFator = Date.prototype.addDays = function(days){
      return this.setDate(this.getDate() + days)
    }
   if (insurer === "Fator") {
      daysafter.setDate(daysafter.getDate()+ 5);
      daysBefore.setDate(daysBefore.getDate()+ 15);
    } */
    // date = date.setDate(date.getDate() + 15);
  }, [])

  function getDisableDate() {
    let dateBefore = new Date();
    let dateAfter = new Date();
    let weekday;
    let disableDate = { after: undefined, before: undefined };

    insurer === "Fator" ?
      dateBefore.setDate(dateBefore.getDate() + 5)
      : dateBefore.setDate(dateBefore.getDate() + 10);
    console.log(dateBefore);
    weekday = dateBefore.getDay();
    console.log("dia da semana", weekday)

    weekday == 6 ?
      dateBefore.setDate(dateBefore.getDate() + 2)
      : weekday == 0 && dateBefore.setDate(dateBefore.getDate() + 1);

    disableDate.before = dateBefore;

    insurer === "Fator" ? dateAfter.setDate(dateAfter.getDate() + 15)
      : dateAfter.setDate(dateAfter.getDate() + 30)

    weekday = dateAfter.getDay();
    console.log("dia da semana", weekday)

    weekday == 6 ?
     dateAfter.setDate(dateAfter.getDate() + 2) 
     : weekday == 0 && dateAfter.setDate(dateAfter.getDate() + 1);

    console.log(dateAfter);
    disableDate.after = dateAfter;

    return disableDate;
  }

  const dayClick = (day, modifiers = {}) => {
    console.log("data", day);
    console.log("Mod", modifiers);
    if (modifiers.disabled == true) {
      console.log("cancelando acao")
      return;
    }
    let dt = new Date(day);
    const week = dt.getDay();
    const stringdate = dt.toLocaleDateString('en-GB');
    setSelectedDay(stringdate);
    console.log("dia semana", week);
  }

  return (

    <>
      <DayPicker
        disabledDays={[
          getDisableDate(),// { daysOfWeek: [0, 6] }
        ]}
        showOutsideDays
        onDayClick={dayClick}
        months={MONTHS}
        weekdaysLong={WEEKDAYS_LONG}
        weekdaysShort={WEEKDAYS_SHORT}
        firstDayOfWeek={0}
        fixedWeeks
      />
      <label>{selectedDay && selectedDay}</label>
      {    /* <button onClick={async ()=>{
      let message = await cache.getMessage("TESTE","en","356",token).catch(e => console.log(e));
      console.log(message);
    }}>teste</button> */}
    </>
  )
}